
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import Card from '../Card/Card';
import Swal from 'sweetalert2';
import axios from 'axios';
const centerText = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}
const div1 = {
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	height: "inherit",
	padding: "3px"
}
const div2 = {
	width: "80%",
	height: "80%",
	background: "#fff",
	boxShadow: "15px 15px 25px #ccc",
	borderRadius: "15px"
}
class engTest extends Component {
	constructor(props) {
		super(props)
		this.state = {
			a1: '',
			a2: '',
			a3: '',
			a4: '',
			a5: '',
			a6: '',
			a7: '',
			a8: '',
			a9: '',
			a10: '',
			a11: '',
			a12: '',
			a13: '',
			a14: '',
			a15: '',
			a16: '',
			a17: '',
			a18: '',
			a19: '',
			a20: '',
			a21: '',
			a22: '',
			a23: '',
			a24: '',
			a25: '',
			a26: '',
			a27: '',
			a28: '',
			a29: '',
			a30: '',
			a31: '',
			minutes: 40,
			seconds: 3,
		}
		this.onChange = this.onChange.bind(this);
		this.submitTest = this.submitTest.bind(this);
		this.startTimer = this.startTimer.bind(this)
		this.timer = this.timer.bind(this)

	}

	startTimer() {
    if (this.state.minutes !== 0 && this.state.seconds !== 0) {
      this.interval = setInterval(this.timer, 1000)
    }
  }

	timer() {

		if (this.state.seconds === 0 & this.state.minutes !== 0) {
			this.setState(prevState => {
				return {
					minutes: prevState.minutes - 1,
					seconds: 59
				}
			})
		} else if (this.state.seconds === 0 && this.state.minutes === 0) {
			clearInterval(this.interval)
			const data = {
				a1: this.state.a1,
				a2: this.state.a2,
				a3: this.state.a3,
				a4: this.state.a4,
				a5: this.state.a5,
				a6: this.state.a6,
				a7: this.state.a7,
				a8: this.state.a8,
				a9: this.state.a9,
				a10: this.state.a10,
				a11: this.state.a11,
				a12: this.state.a12,
				a13: this.state.a13,
				a14: this.state.a14,
				a15: this.state.a15,
				a16: this.state.a16,
				a17: this.state.a17,
				a18: this.state.a18,
				a19: this.state.a19,
				a20: this.state.a20,
				a21: this.state.a21,
				a22: this.state.a22,
				a23: this.state.a23,
				a24: this.state.a24,
				a25: this.state.a25,
				a26: this.state.a26,
				a27: this.state.a27,
				a28: this.state.a28,
				a29: this.state.a29,
				a30: this.state.a30,
				a31: this.state.a31
			}
			console.log(data)
			axios.post(`/api/engApi/saveTestResult`, data)
				.then(resp => {
					console.log(resp)
					Swal.fire(
						'Niste na vreme završili test, ali su rezultati poslati! ',
						resp.data.message,
						resp.data.sign
					)
					this.props.history.push('/welcomePage')
				})
				.catch(err => {
					console.log(err)
				})

		} else if (this.state.seconds > 0) {
			this.setState(prevState => {
				return {
					seconds: prevState.seconds - 1
				}
			})
		}
	}

	async componentDidMount() {
		this.startTimer()
		await axios.post(`/api/engApi/checkIfTestIsAccessed/`)
			.then(resp => {
				if (resp.data.message === true) {
					Swal.fire(
						'Problem',
						'Test je već rađen sa ovog naloga!',
						'error'
					)
					this.props.history.push('/welcomePage')
				}
			})
			.catch(err => {

			})
	}


	async submitTest(e) {
		e.preventDefault();
		Swal.fire({
			title: 'Da li sigurno želiš da predaš test?',
			text: "Nećeš moći da ga radiš ponovo",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			cancelButtonText: 'Ček da proverim',
			confirmButtonText: 'Predaj!'
		}).then(async (result) => {
			if (result.isConfirmed) {
				const data = {
					a1: this.state.a1,
					a2: this.state.a2,
					a3: this.state.a3,
					a4: this.state.a4,
					a5: this.state.a5,
					a6: this.state.a6,
					a7: this.state.a7,
					a8: this.state.a8,
					a9: this.state.a9,
					a10: this.state.a10,
					a11: this.state.a11,
					a12: this.state.a12,
					a13: this.state.a13,
					a14: this.state.a14,
					a15: this.state.a15,
					a16: this.state.a16,
					a17: this.state.a17,
					a18: this.state.a18,
					a19: this.state.a19,
					a20: this.state.a20,
					a21: this.state.a21,
					a22: this.state.a22,
					a23: this.state.a23,
					a24: this.state.a24,
					a25: this.state.a25,
					a26: this.state.a26,
					a27: this.state.a27,
					a28: this.state.a28,
					a29: this.state.a29,
					a30: this.state.a30,
					a31: this.state.a31
				}
				console.log(data)
				await axios.post(`/api/engApi/saveTestResult`, data)
					.then(resp => {
						console.log(resp)
						Swal.fire(
							'Poslato!',
							resp.data.message,
							resp.data.sign
						)
						this.props.history.push('/welcomePage')
					})
					.catch(err => {
						console.log(err)
					})
			}
		})

	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	render() {


		return (
			<div className="Content">

				<div style={{ position: 'fixed' }}><Card content={<Row>Vreme: {this.state.minutes}:{this.state.seconds}</Row>} /></div>

				<div style={div1}>
					<div style={div2}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br />
								Zdravo {this.props.auth.user.name}, pred tobom je test engleskog jezika, Srećno!
								<br />
							</div>
						</div>
					</div>
				</div>
				<br />
				<div style={div1}>
					<div style={div2}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								I. Complete the sentence by using the word in parentheses at the correct tense:
								<br />
								1.The guard (sleep) <input type='text' name='a1' onChange={this.onChange} /> when we (knock) <input type='text' name='a2' onChange={this.onChange} /> at the door.
								<br />
								2.I didn’t want to meet Michael so when he entered the room I (leave)<input type='text' name='a3' onChange={this.onChange} />.
								<br />
								3.Jane always (mention) <input type='text' name='a4' onChange={this.onChange} /> her problems to her sister.
								<br />
								4.You should go out. You (sit) <input type='text' name='a5' onChange={this.onChange} /> in this place all morning.
								<br />
								5.Although he (not see) <input type='text' name='a6' onChange={this.onChange} /> his new director yet, he (be) <input type='text' name='a7' onChange={this.onChange} /> afraid of him.
								<br />
								6.My dog (walk) <input type='text' name='a8' onChange={this.onChange} /> along quietly when Mr. Smith Alsatian dog (attack) <input type='text' name='a9' onChange={this.onChange} /> him.
								<br />
								7.Before we (go) <input type='text' name='a10' onChange={this.onChange} /> far, we (know) <input type='text' name='a11' onChange={this.onChange} /> that we (lose) <input type='text' name='a12' onChange={this.onChange} /> way.
								<br />
								8.When I arrived the lecture already (start) <input type='text' name='a13' onChange={this.onChange} /> and the professor <input type='text' name='a14' onChange={this.onChange} /> (write) on the panel.
								<br />
								9.If you <input type='text' name='a15' onChange={this.onChange} /> (not listen) to the music, why you <input type='text' name='a16' onChange={this.onChange} /> (not turn) it off?
								<br />
								10.Peter suddenly <input type='text' name='a17' onChange={this.onChange} /> (realise) that he (travel) <input type='text' name='a18' onChange={this.onChange} /> the wrong direction.
								<br />
							</div>
						</div>
					</div>
				</div>
				<br />
				<div style={div1}>
					<div style={div2}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br />
								II. Match the terms and use it in sentences:
								<table>
									<tr>
										<tr>
											<td>.Assembly</td><td style={{ width: '50px' }} /><td>security</td>
										</tr>
										<tr>
											<td>.Multi</td><td style={{ width: '50px' }} /><td>language</td>
										</tr>
										<tr>
											<td>.Special</td><td style={{ width: '50px' }} /><td>line</td>
										</tr>
										<tr>
											<td>.Firewall</td><td style={{ width: '50px' }} /><td>tasking</td>
										</tr>
										<tr>
											<td>.High-level</td><td style={{ width: '50px' }} /><td>services</td>
										</tr>
										<tr>
											<td>.Newswire</td><td style={{ width: '50px' }} /><td>offer</td>
										</tr>
									</tr>
								</table>
								<br />
								1.C# is an example of <input type='text' name='a19' onChange={this.onChange} /> used in programming .
								<br />
								2.Hurry up to use our <input type='text' name='a20' onChange={this.onChange} /> buy five rolls of toilet paper and you will get five for free!
								<br />
								3.Telegraf and Tanjug are some of the best known <input type='text' name='a21' onChange={this.onChange} /> in Serbia.
								<br />
								4.Unlike the most men , Michael is very good at <input type='text' name='a22' onChange={this.onChange} /> ,doing several things at the same time.
								<br />
								5.Install a <input type='text' name='a23' onChange={this.onChange} /> to prevent hackers from breaking into your internal network.
								<br />
								6.In 1937, Toyota installed its first <input type='text' name='a24' onChange={this.onChange} /> for the car parts production in her factory.
							</div>
						</div>
					</div>
				</div>
				<br />
				<div style={div1}>
					<div style={div2}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br />
								III. Insert the conditional correctly and translate the sentence:
								<br />
								1.Ako je lift pokvaren, možeš da se zaglaviš.
								<br />
								<input type='text' name='a25' onChange={this.onChange} style={{ width: '500px' }} />
								<br />
								2.Ja ću prihvatiti vašu ponudu pod uslovom da mi obezbedite opremu za rad.
								<br />
								<input type='text' name='a26' onChange={this.onChange} style={{ width: '500px' }} />
								<br />
								3.Ako zalivaš cveće redovno, ono brže raste.
								<br />
								<input type='text' name='a27' onChange={this.onChange} style={{ width: '500px' }} />
								<br />
								4.On bi živeo u inostranstvu kada bi mogao to da priušti.
								<br />
								<input type='text' name='a28' onChange={this.onChange} style={{ width: '500px' }} />
								<br />
								5.Recimo da ja pristanem na taj predlog, šta ćeš ti uraditi?
								<br />
								<input type='text' name='a29' onChange={this.onChange} style={{ width: '500px' }} />
								<br />
								6.Zamisli da postoji lek za sve bolesti.
								<br />
								<input type='text' name='a30' onChange={this.onChange} style={{ width: '500px' }} />
								<br />
							</div>
						</div>
					</div>
				</div>
				<br />
				<div style={div1}>
					<div style={div2}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br />
								IV. Create an order (in the form of a business email) based
								on the following data:
								<br /><br />
								Gomex Company, retail chain from Zrenjanin, has more than 230 retail stores
								in Serbia, and is thinking about improving business processes, customer
								satisfaction and loyalty, and is also struggling with labor shortages.
								Marketing Director of Gomex is Mr. Petar Petrović.
								The email address of the marketing director is: petar.petrovic@gomex.com
								<br /><br />
								Galeb Electronics Company from Šabac is launching new line of products for
								retail digitization, which include self-checkout, digital signage, digital prices
								and interactive kiosks. Galeb has exposed new products in its branch in Novi
								Beograd, Bulevar Mihajla Pupina 10z, and is inviting potential customer for
								presentation of these products and benefits of digitization discussion.
								Sales Director of Galeb Electronics is Mr. Marko Markovic
								The email address of the sales director is: marko.markovic@galeb.com
								<br /><br />
								<textarea
									className="form-control"
									style={{ height: '300px' }}
									name="a31"
									onChange={this.onChange}
								/>
							</div>
						</div>
					</div>
				</div>
				<br />
				<div style={div1}>
					<div style={div2}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br />
								<div style={centerText}>
									<input
										type="submit"
										value="Predaj test"
										onClick={this.submitTest}
										className="btn-fill col-md-3 pull-center btn btn-info"
										style={{ margin: '3px' }}
									/>
								</div>
								<br />
							</div>
						</div>
					</div>
				</div>
			</div >
		)
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
});

export default connect(
	mapStateToProps,
)(engTest);